import { jsxs as r, jsx as e } from "react/jsx-runtime";
import { tv as c } from "tailwind-variants";
import m from "./Bubble.js";
const u = c({
  slots: {
    wrapper: [
      "bg-white",
      "border",
      "border-neutral-200",
      "rounded-xl",
      "shadow-md"
    ],
    bubble: ["bg-cyan-500", "italic"],
    heading: ["font-secondary", "font-semibold", "text-lg"]
  },
  variants: {
    isActive: {
      true: {
        wrapper: ["bg-blue-500", "border-blue-500"],
        bubble: ["bg-white", "text-blue-500"],
        heading: ["text-white"]
      }
    }
  }
});
function f({ children: a, heading: s, index: l, isActive: t, onClick: n }) {
  const i = (p) => {
    p.preventDefault(), n();
  }, { wrapper: o, bubble: b, heading: d } = u({ isActive: t });
  return /* @__PURE__ */ r("details", { className: o(), onClick: i, open: t, children: [
    /* @__PURE__ */ r("summary", { className: "cursor-pointer flex gap-4 items-center list-none px-5 py-4 [&::-webkit-details-marker]:hidden", children: [
      /* @__PURE__ */ e(m, { className: b(), size: "sm", children: l + 1 }),
      /* @__PURE__ */ e("span", { className: d(), children: s })
    ] }),
    /* @__PURE__ */ e("p", { className: "p-5 pt-0 text-neutral-200", children: a })
  ] });
}
export {
  f as default
};
